import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";

// Production web+API origin (your server), used ONLY inside the native Android/iOS shell where
// window.location.origin is the bundled-asset origin (https://localhost).
// Must match the App Links host in android/app/src/main/AndroidManifest.xml and the assetlinks.json served there.
export const NATIVE_WEB_ORIGIN = "https://app.uursnutritionist.com";
// Custom URL scheme registered in AndroidManifest.xml; used to bounce the OAuth result back into the app.
export const NATIVE_URL_SCHEME = "com.uurs.nutritionist";
// Web path the native shell asks Emergent Auth to return to; the web page then bounces to NATIVE_URL_SCHEME.
export const NATIVE_AUTH_RETURN_PATH = "/native-auth";

export const isNative = () => Capacitor.isNativePlatform();

// Web origin to use for OAuth redirects: real origin on web, production domain in the native shell.
export const getAuthOrigin = () => (isNative() ? NATIVE_WEB_ORIGIN : window.location.origin);

// Where Emergent Auth should land after Google login: /home on web, the native bounce page in the shell.
export const getAuthRedirectUrl = () => getAuthOrigin() + (isNative() ? NATIVE_AUTH_RETURN_PATH : "/home");

export const nativeDeepLink = (sessionId) => `${NATIVE_URL_SCHEME}://auth#session_id=${encodeURIComponent(sessionId)}`;

// Forward App Link / deep-link opens (https App Link or custom scheme) carrying #session_id into the in-app router.
export const listenForAppLinks = (onUrl) => {
  if (!isNative()) return () => {};
  const handle = CapApp.addListener("appUrlOpen", ({ url }) => {
    try {
      const u = new URL(url);
      onUrl((u.pathname || "/") + u.search + u.hash);
    } catch {}
  });
  return () => { handle.then((h) => h.remove()); };
};
